import React, { useContext, useEffect, useState } from "react";
import Modal from "../../components/Modal";
import { Pagination, PaginationProps } from "antd";
import AddCompany from "./AddCompany";
import { Company } from "../../interfaces/Company";
import { exportCompanies, getCompanies } from "../../apis/company";
import Filters from "../../components/Filters";
import { Filter } from "../../interfaces/Filter";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { LanguageContext } from "../../providers/LanguageProvider";
import { format } from "date-fns";
import CommonPagination from "../../components/CommanPagination";
const CompanyList = () => {
  const [editableId, setEditableId] = useState(null);
  const [meta, setMeta] = useState<any>();
  const [isCompanyModalOpen, setCompanyModalVisibility] =
    useState<boolean>(false);
  const { translate: t } = useContext(LanguageContext);

  const [companies, setCompanies] = useState<Array<Company>>([
    {
      name: "",
      code: "",
    },
  ]);

  const navigate = useNavigate();
  const { search } = useLocation();

  const companyFilters: Array<Filter> = [
    {
      label: "Name ",
      key: "name",
      value: "",
      component: "input",
    },
  ];

  const [filters] = useState<Array<Filter>>(companyFilters);
  const [isClearFilterList] = useState(false);
  const [, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (search) {
      const filters = JSON.parse(
        '{"' +
          decodeURI(search.substring(1))
            .replace(/\+/g, " ")
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"') +
          '"}'
      );
      fetchCompanies({ per_page: 10, ...filters });
    } else {
      fetchCompanies({ per_page: 10 });
    }
  }, [search]);

  const handleCloseModal = () => {
    setEditableId(null);
    setCompanyModalVisibility(false);
    fetchCompanies();
  };

  const fetchCompanies = (params = {}) => {
    getCompanies(params).then((res: any) => {
      setCompanies(res.data);
      setMeta(res.meta);
    });
  };

  const handleEditCompany = (payload: any) => {
    setEditableId(payload.id);
    setCompanyModalVisibility(true);
  };

  //use per_page
  // const onPaginationChange: PaginationProps["onChange"] = (page, pageSize) => {
  //   fetchCompanies({ page, per_page: pageSize });
  // };
  const onPaginationChange = (page: number, pageSize?: number) => {
  fetchCompanies({ page, per_page: pageSize || 10 }); 
};

  const handleFilters = (params: any) => {
    if (params.length > 0) {
      let updatedQueryParams = new URLSearchParams();
      params.forEach((i: any) => {
        updatedQueryParams.set(i.key, i.value);
      });
      setSearchParams(updatedQueryParams.toString());
    } else {
      navigate(`/companies`);
    }
  };

  const downloadCompaniesList = () => {
    if (search) {
      const filters = JSON.parse(
        '{"' +
          decodeURI(search.substring(1))
            .replace(/\+/g, " ")
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"') +
          '"}'
      );
      exportCompaniesList({ ...filters });
    } else {
      exportCompaniesList({});
    }
  };

  const exportCompaniesList = (params: any) => {
    exportCompanies(params).then((res: any) => {
      downloadFile(res.data);
    });
  };

  const downloadFile = (data: any) => {
    const blob = new Blob([data], { type: "application/vnd.ms-excel" });
    const url = window.URL.createObjectURL(blob);
    const downloadLink = document.createElement("a");
    downloadLink.href = url;
    const today = format(new Date(), "dd_MM_yyyy_hh_mm");
    downloadLink.download = "companies-" + today + ".xlsx";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="lg:hidden sm:flex sm:items-center">
        <div className="flex lg:hidden">
          <div className="sm:flex-auto">
            <h1 className="text-base font-semibold leading-6 text-gray-900">
              {t("company")}
            </h1>
          </div>
          <div className="flex flex-row-reverse w-full">
            <div>
              <button
                type="button"
                onClick={() => setCompanyModalVisibility(true)}
                className="block px-3 py-2 text-sm font-semibold text-center text-white rounded-md shadow-sm bg-primary hover:bg-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-hover"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-4 h-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 4.5v15m7.5-7.5h-15"
                  />
                </svg>
              </button>
            </div>
            <div>
              <button
                type="button"
                onClick={() => downloadCompaniesList()}
                className="block px-3 py-2 mx-2 text-sm font-semibold text-center text-white capitalize rounded-md shadow-sm bg-primary hover:bg-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-hover"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-4 h-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15M9 12l3 3m0 0 3-3m-3 3V2.25"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="hidden lg:block lg:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            {t("company")}
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            {t("company_description")}
          </p>
        </div>
        <div className="mx-2 mt-4 sm:mt-0 sm:ml-16 sm:flex">
          <div className="mr-2">
            <Filters
              clearFilterList={isClearFilterList}
              filters={filters}
              fetchList={(appliedFilters: any) => handleFilters(appliedFilters)}
            ></Filters>
          </div>
          <button
            type="button"
            onClick={() => setCompanyModalVisibility(true)}
            className="block px-3 py-2 text-sm font-semibold text-center text-white rounded-md shadow-sm bg-primary hover:bg-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            {t("add_company")}
          </button>
          <button
            type="button"
            onClick={() => downloadCompaniesList()}
            className="block px-3 py-2 ml-3 text-sm font-semibold text-center text-white capitalize rounded-md shadow-sm bg-primary hover:bg-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            {t("export")}
          </button>
        </div>
      </div>
      <div className="flow-root mt-8">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                    >
                      {t("name")}
                    </th>

                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 capitalize"
                    >
                      {t("actions")}
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {companies && companies.length > 0 ? (
                    companies.map((company, index) => (
                      <tr key={index}>
                        <td className="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 capitalize whitespace-nowrap sm:pl-6">
                          {company.name}
                        </td>

                        <td className="relative py-4 pl-3 pr-4 text-sm font-medium text-left whitespace-nowrap sm:pr-6">
                          <button
                            onClick={() => handleEditCompany(company)}
                            className="block px-3 py-2 text-sm font-semibold text-center text-white rounded-md shadow-sm bg-primary hover:bg-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                          >
                            {t("edit")}
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={3}
                        className="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6"
                      >
                        {t("Record Not Found")}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* <div className="flex justify-end pt-5">
              <Pagination
                defaultCurrent={1}
                defaultPageSize={10}
                total={meta?.total}
                onChange={onPaginationChange}
              />
            </div> */}
            <CommonPagination meta={meta} onChange={onPaginationChange} />
          </div>
        </div>
      </div>
      {isCompanyModalOpen && (
        <Modal
          title={editableId ? "Update Company" : "Add Company"}
          onClose={() => handleCloseModal()}
          modalContent={
            <AddCompany
              editableId={editableId}
              closeModal={() => handleCloseModal()}
            />
          }
        />
      )}
    </div>
  );
};

export default CompanyList;
